import axios, { AxiosHeaders, type AxiosInstance } from 'axios'
import { v4 as uuidv4 } from 'uuid'

import store from '@/store'
import { getToken } from '@/utils/auth'

export function createLocationGroupsHttpClient(baseURL = import.meta.env.VITE_BASE_API): AxiosInstance {
  const client = axios.create({ baseURL })
  client.interceptors.request.use(config => {
    config.headers = AxiosHeaders.from(config.headers)
    if (store.getters.token) config.headers.set('Authorization', getToken())
    config.headers.set('traceId', uuidv4())
    return config
  })
  return client
}
